import { render, staticRenderFns } from "./TeacherSidemenuLayout.vue?vue&type=template&id=7144f4fb&scoped=true&lang=pug&"
import script from "./TeacherSidemenuLayout.vue?vue&type=script&lang=ts&"
export * from "./TeacherSidemenuLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7144f4fb",
  null
  
)

export default component.exports